import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth/auth.service';

export const AuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  if(environment.maintenanceMode) return router.parseUrl('/maintenance');
  if (authService.isLoggedIn()) return true;
  return router.parseUrl('/login');
}
